import React, { useState } from "react";
import ButtonGroup from '@mui/material/ButtonGroup';
import Button from '@mui/material/Button';
import { Box ,Typography} from "@mui/material";
import styled from "styled-components";
import BookingFooter from "./BookingFooter";
const Styles = styled.div`
  display: inline-block;
  padding-left:0px;
   flex-direction: row; 
   margin-top:10px;
   /* min-width: 50%;  */
  .App {
  /* font-family: sans-serif;
  font-display:inherit; */
  text-align: left;
  flex-direction: row; 
}
 .button {
    top:0px;
    width:5px;
    height:20px;
    background-color:black;
    color:white;
 }
 .input{
    background-color:white;
    color:black;
    width:30px;
    height:20px;
 }

`
export default function Profile(props) {

  const [count, setCount] = useState(0); // useState returns a pair. 'count' is the current state. 'setCount' is a function we can use to update the state.

  function increment() {
    //setCount(prevCount => prevCount+=1);
    setCount(function (prevCount) {
      return (prevCount += 1);
    });
  }
  function changeMenu() {
    props.changeMyMenu(0)
  }
  function decrement() {
    setCount(function (prevCount) {
      if (prevCount > 0) {
        return (prevCount -= 1); 
      } else {
        return (prevCount = 0);
      }
    });
  }

  return (
    <>
    
    <div  style={{display:'inline-block',width:'50%%'}}>

    </div>
    
    <Box
  sx={{
    mt: 3,  // این رو حذف کنید
    display: "flex",
  //  justifyContent: "center",
  //  alignItems: "center",
    backgroundColor: "white",
    border: "3px solid #FFD43B",
    borderRadius: "10px",
    boxShadow: 1,
    p: 1.2,
    gap: 1,
    maxWidth: "60%",
    mx: "auto",

    position: "fixed",   // ثابت کردن باکس تاریخ
    top: "140px",         // فاصله از بالای صفحه به اندازه ارتفاع AppBar
    left: "50%",  
    width:'80%', 
    height:'40%',      // وسط چین افقی
    transform: "translateX(-50%)",  // مرکز کردن افقی
    zIndex: 999,         // روی تمام المان‌ها قرار بگیرد
    padding: "10px",     // کمی فاصله از کناره‌ها
    boxSizing: "border-box",  // اطمینان از اینکه padding روی اندازه کلی اثر نگذارد
  }}
    >
    <Styles   >
    <div className="App" >
   <label> User Name : {localStorage.getItem("U_Name")}</label>
    </div>
    </Styles> 
   </Box>


    </>
    
  );
}
